var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.47 19.409a.75.75 0 1 0 1.06 1.06L20.44 4.56a.75.75 0 0 0-1.06-1.06l-2.86 2.86A9.707 9.707 0 0 0 12 5.249c-4.641 0-8.523 3.243-9.509 7.585a.75.75 0 0 0 1.463.332A8.253 8.253 0 0 1 15.398 7.48l-2.6 2.6a4 4 0 0 0-4.72 4.72l-4.608 4.609Zm8.53-1.41c-.85 0-1.637-.264-2.284-.715l5.568-5.568A4 4 0 0 1 12 18Zm8.045-4.833a8.234 8.234 0 0 0-2.212-4l1.061-1.06a9.735 9.735 0 0 1 2.614 4.728.75.75 0 1 1-1.463.332Z",
    clipRule: "evenodd"
  })));
};
export default SvgEyeClosed;